import type { AppNotification } from '../types/notifications'

export function entityProfileHref(
  entityType: 'company' | 'person' | string | null,
  entityId: string | null
): string | null {
  if (!entityType || !entityId) return null
  if (entityType === 'company') return `/company/${entityId}`
  if (entityType === 'person') return `/person/${entityId}`
  return null
}

export function notificationHref(notification: AppNotification): string | null {
  return entityProfileHref(notification.entityType, notification.entityId)
}
